
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Field, DropdownField } from '@samc/centricity-core';
import { AjaxHelper } from '@samc/common';
import { BuyerSource } from '@/Sources';
import { IPreference } from '@/Interfaces';

@Component({
  name: 'buyer-dropdown-field',
  components: { Field, DropdownField }
})
export default class BuyerDropdownField extends Vue {
  @Prop() public value!: string;
  @Prop({ default: '' }) public errorText!: string;
  @Prop({ default: 'Buyer' }) public label!: string;
  @Prop({ type: Boolean, default: false }) public disabled!: boolean;
  @Prop({ type: Boolean, default: false }) public autoAssign!: boolean;
  @Prop() public placeholder!: string;

  public source: BuyerSource = new BuyerSource(true);

  public get val(): string { return this.value; }
  public set val(value: string) {
    this.$emit('input', value);
  }

  /**
   * Lifecycle hook is called once this dropdown is created
   **/
  public async mounted() {
    if (this.val === '' || this.val === null) {
      this.val = await this.getDefaultBuyer(); //set them both in case this loads after data source
    }
  }

  /**
   * Helper method is meant to load the default buyer for this dropdown
   *
   * TODO: Probably create this into a generic function to get preferences
   **/
  public async getDefaultBuyer() {
    const key = 'DefaultBuyer';
    const helper = new AjaxHelper('/configApi/v1/preferences', null, null, null);
    const defBuyers = await helper.getData<IPreference[]>('', { key });
    if (!defBuyers || !defBuyers.length) {
      return '';
    }
    return this.getBestMatch(defBuyers, key)?.value.toLowerCase() ?? '';
  }

  /**
   * Helper method is meant to get the best match based on the preferences.
   *
   * TODO: Probably make this a generic function of some kind
   *
   * @param prefs The perferences loaded for this user
   * @param key The current key we are working with
   * @param scope0 The current scope 0 we should use to narrow down the pref
   * @param scope1 The current scope 0 we should use to narrow down the pref
   * @param scope2 The current scope 0 we should use to narrow down the pref
   */
  public getBestMatch(prefs: IPreference[], key: string, scope0?: string, scope1?: string, scope2?: string): IPreference | null {
    let bmIdx = 0;
    let bmKeys = -1;
    for (let i = 0; i < prefs.length; i++) {
      let keyMatch = 0;
      if (prefs[i].key.toLowerCase() === key.toLowerCase()) { keyMatch++; }
      if (scope0 && prefs[i].scope0.toLowerCase() === scope0.toLowerCase()) { keyMatch++; }
      if (scope1 && prefs[i].scope1.toLowerCase() === scope1.toLowerCase()) { keyMatch++; }
      if (scope2 && prefs[i].scope2.toLowerCase() === scope2.toLowerCase()) { keyMatch++; }
      if (keyMatch > bmKeys) {
        bmKeys = keyMatch;
        bmIdx = i;
      }
    }
    return prefs[bmIdx] ?? null;
  }
}
